import { Pipe, PipeTransform } from '@angular/core';
import { RouteEvent, RouteEventEnum } from '@fleet-beat/core';
import { SelectOptionsRouteEvent } from '../models/select-options-route-event.model';

@Pipe({
  name: 'routeEventPipe',
})
export class RouteEventPipe implements PipeTransform {
  transform(value: RouteEventEnum): SelectOptionsRouteEvent {
    if (!value && value !== 0) return null;
    return RouteEvent.find((event: SelectOptionsRouteEvent) => event.value === value);
  }
}
